import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { RgbaStringColorPicker } from "react-colorful";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import Divider from '@mui/material/Divider';
import Slecetor from "./PopoverColorPicker/Slecetor"
import { useContext, useEffect, useState } from "react";
import MainContext from "../../../context/mainContext";
import { customToastify } from "../../pages/utils/utilsFunctions"
import Button from '@mui/material/Button';
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import { getWordLearningListByLangApi, getReadyWordLearningListByLangApi } from "../../../services/leitnerApi"

function createData(name, controlCo, controlBkCo, controlRp, controlPs) {
  return { name, controlCo, controlBkCo, controlRp, controlPs };
}

export default function UserWordsStyles({ handleOpenModalAlert, handlePlayingStatus }) {
  const { handleOpenSignInBox, subWordLearningStyles, handleSubWordLearningStyles, userWordsDifficultyLevel, handleUserWordsDifficultyLevel, videoInfo, userTypes } = useContext(MainContext);

  const handleSetColor = (type, level, value) => {
    if (userTypes.includes("userPremium") || userTypes.includes("admin") || userTypes.includes("freetrial_all")) {
      let cpStyles = { ...subWordLearningStyles }
      cpStyles[`${type}_${level}`] = value
      handleSubWordLearningStyles(cpStyles)
    } else if (userTypes.includes("user")) {
      handleOpenModalAlert()
    } else {
      handlePlayingStatus(false)
      handleOpenSignInBox()
      customToastify("error", "لطفا ابتدا لاگین کنید")
    }
  }


  const getDifficultyWordLevel = (num) => {
    num++
    let factor = 15
    let level = Math.ceil(Math.sqrt(num / factor))
    if (level > 9) level = 9
    return level
  }

  const getWordLearningListByLang = async (changedLevel) => {
    try {
      const fromLang = videoInfo["subtitleOneLanguage"]
      const toLang = videoInfo["subtitleTwoLanguage"]
      let AllUserWordslearningLevel = { words: [], levels: [] };
      if (parseInt(changedLevel) !== 10) {
        let userLeitnerlearningLevel1 = [];
        let userLeitnerlearningLevel2 = [];
        let userLeitnerlearningLevel3 = [];
        let userLeitnerlearningLevel4 = [];
        let userLeitnerlearningLevel5 = [];
        let userLeitnerlearningLevel6 = [];
        let userLeitnerlearningLevel7 = [];
        let userLeitnerlearningLevel8 = [];
        let userLeitnerlearningLevel9 = [];
        let alreadyGetWord = false
        for (let lvl = 1; lvl < 10; lvl++) {
          if (userWordsDifficultyLevel["levels"].indexOf(lvl) >= 0) {
            alreadyGetWord = true
            break
          }
        }
        if (alreadyGetWord) {
        } else {
          let remainWordLearning = true
          let pageNum = 1
          while (remainWordLearning) {
            const getWordLearningListByLang = await getWordLearningListByLangApi({
              fromLang,
              toLang,
            }, { page: pageNum, perPage: 50 });
            if (
              getWordLearningListByLang["data"] &&
              getWordLearningListByLang["data"]["success"]
            ) {
              getWordLearningListByLang["data"]["data"]["docs"].forEach(
                (element) => {
                  if (element["learningLevel"] == 1) {
                    userLeitnerlearningLevel1.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 2) {
                    userLeitnerlearningLevel2.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 3) {
                    userLeitnerlearningLevel3.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 4) {
                    userLeitnerlearningLevel4.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 5) {
                    userLeitnerlearningLevel5.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 6) {
                    userLeitnerlearningLevel6.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 7) {
                    userLeitnerlearningLevel7.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 8) {
                    userLeitnerlearningLevel8.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                  if (element["learningLevel"] == 9) {
                    userLeitnerlearningLevel9.push({
                      card: element["frontCard"],
                      allLearningTimes: element["allLearningTimes"],
                    });
                    AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                    AllUserWordslearningLevel["levels"].push(getDifficultyWordLevel(element["allLearningTimes"]))
                  }
                }
              );
              if (getWordLearningListByLang["data"]["data"]["hasNextPage"]) pageNum++
              else remainWordLearning = false
            } else {
              remainWordLearning = false
            }
          }
          let cp = { ...userWordsDifficultyLevel }
          cp["words"].push(...AllUserWordslearningLevel["words"])
          cp["levels"].push(...AllUserWordslearningLevel["levels"])
          handleUserWordsDifficultyLevel(cp)
        }
      } else {
        if (userWordsDifficultyLevel["levels"].indexOf(10) >= 0) {
        } else {
          let remainReadyWordLearning = true
          let pageNum = 1
          while (remainReadyWordLearning) {
            const getReadyWordLearningListByLang = await getReadyWordLearningListByLangApi({
              fromLang,
              toLang,
            }, { page: pageNum, perPage: 50 });
            if (
              getReadyWordLearningListByLang["data"] &&
              getReadyWordLearningListByLang["data"]["success"]
            ) {
              getReadyWordLearningListByLang["data"]["data"]["docs"].forEach(
                (element) => {
                  AllUserWordslearningLevel["words"].push(element["frontCard"].toLowerCase())
                  AllUserWordslearningLevel["levels"].push(10)
                }
              );
              if (getReadyWordLearningListByLang["data"]["data"]["hasNextPage"]) pageNum++
              else remainReadyWordLearning = false
            } else {
              remainReadyWordLearning = false
            }
            let cp = { ...userWordsDifficultyLevel }
            cp["words"].push(...AllUserWordslearningLevel["words"])
            cp["levels"].push(...AllUserWordslearningLevel["levels"])
            handleUserWordsDifficultyLevel(cp)
          }
        }
      }
    } catch (error) {
      console.log("getAllWordLearningListByLang", error)
    }
  }


  const changeColorsToggle = (type, level) => {
    if (userTypes.includes("userPremium") || userTypes.includes("admin") || userTypes.includes("freetrial_all")) {
      let cpStyles = { ...subWordLearningStyles }
      cpStyles[`${type}_on_${level}`] = !cpStyles[`${type}_on_${level}`]
      if (cpStyles[`${type}_on_${level}`]) {
        cpStyles[`${type}_on`] = true
        getWordLearningListByLang(level)
      }
      else {
        let chceckAll = false
        for (let lvl = 1; lvl < 10; lvl++) {
          if (cpStyles[`${type}_on_${lvl}`]) chceckAll = true
        }
        if (chceckAll) cpStyles[`${type}_on`] = true
        else cpStyles[`${type}_on`] = false
      }
      handleSubWordLearningStyles(cpStyles)
    } else if (userTypes.includes("user")) {
      handleOpenModalAlert()
    } else {
      handlePlayingStatus(false)
      handleOpenSignInBox()
      customToastify("error", "لطفا ابتدا لاگین کنید")
    }
  }

  const toggleIcon = (type, level) => {
    return subWordLearningStyles[`${type}_on_${level}`] ? <ToggleOnIcon onClick={() => { changeColorsToggle(type, level) }} color={"success"} /> : <ToggleOffIcon onClick={() => { changeColorsToggle(type, level) }} color={"error"} />
  }

  const colorSelector = (type, level) => {
    return subWordLearningStyles[`${type}_on_${level}`] ? <Box sx={{ display: "flex", m: 0, p: 0 }} ><Slecetor handleSetColor={handleSetColor} type={type} level={level} /></Box> : <Box sx={{ display: "none" }} ><Slecetor /></Box>
  }

  const rpPsSelector = (type, level) => {
    return <select value={subWordLearningStyles[`${type}_${level}`]} style={{ maxWidth: "35px", padding: 0, margin: 0, textAlign: "center" }} name="cars" id="cars" onChange={(e) => { rpPsChange(type, level, e.target.value) }}>
      <option value={0} >0</option>
      <option value={1} >1</option>
      <option value={2} >2</option>
      <option value={3} >3</option>
      <option value={4} >4</option>
      <option value={5} >5</option>
    </select>
  }

  const helpClick = () => {
    window.open("https://doc.umlang.com/", "mozillaWindow", "popup");
  }
  const rpPsChange = (type, level, value) => {
    if (userTypes.includes("userPremium") || userTypes.includes("admin") || userTypes.includes("freetrial_all")) {
      value = parseInt(value)
      if (isNaN(value) || value < 0 || value > 5) {
        customToastify("error", "لطفا فقط از اعداد بین 0 تا 5 استفاده کنید", 3000, "top-center")
      } else {
        let cpStyles = { ...subWordLearningStyles }
        cpStyles[`${type}_${level}`] = value
        if (value !== 0) {
          cpStyles[`${type}_on`] = true
          getWordLearningListByLang(level)
        }
        else {
          let chceckAll = false
          for (let lvl = 1; lvl < 10; lvl++) {
            if (cpStyles[`${type}_${lvl}`] !== 0) chceckAll = true
          }
          if (chceckAll) cpStyles[`${type}_on`] = true
          else cpStyles[`${type}_on`] = false
        }
        handleSubWordLearningStyles(cpStyles)
      }
    } else if (userTypes.includes("user")) {
      handleOpenModalAlert()
    } else {
      handleOpenSignInBox()
      handlePlayingStatus(false)
      customToastify("error", "لطفا ابتدا لاگین کنید")
    }
  }

  const rows = [
    createData('آماده یادگیری', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "10")} {colorSelector("co", "10")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "10")} {colorSelector("bk", "10")}</Paper>,
      rpPsSelector("rp", "10"), rpPsSelector("ps", "10")),
    createData(<Divider />, <Divider />, <Divider />, <Divider />),
    createData('سطح 1', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "1")} {colorSelector("co", "1")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "1")} {colorSelector("bk", "1")}</Paper>,
      rpPsSelector("rp", "1"), rpPsSelector("ps", "1")),
    createData('سطح 2', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "2")} {colorSelector("co", "2")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "2")} {colorSelector("bk", "2")}</Paper>,
      rpPsSelector("rp", "2"), rpPsSelector("ps", "2")),
    createData('سطح 3', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "3")} {colorSelector("co", "3")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "3")} {colorSelector("bk", "3")}</Paper>,
      rpPsSelector("rp", "3"), rpPsSelector("ps", "3")),
    createData('سطح 4', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "4")} {colorSelector("co", "4")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "4")} {colorSelector("bk", "4")}</Paper>,
      rpPsSelector("rp", "4"), rpPsSelector("ps", "4")),
    createData('سطح 5', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "5")} {colorSelector("co", "5")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "5")} {colorSelector("bk", "5")}</Paper>,
      rpPsSelector("rp", "5"), rpPsSelector("ps", "5")),
    createData('سطح 6', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "6")} {colorSelector("co", "6")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "6")} {colorSelector("bk", "6")}</Paper>,
      rpPsSelector("rp", "6"), rpPsSelector("ps", "6")),
    createData('سطح 7', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "7")} {colorSelector("co", "7")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "7")} {colorSelector("bk", "7")}</Paper>,
      rpPsSelector("rp", "7"), rpPsSelector("ps", "7")),
    createData('سطح 8', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "8")} {colorSelector("co", "8")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "8")} {colorSelector("bk", "8")}</Paper>,
      rpPsSelector("rp", "8"), rpPsSelector("ps", "8")),
    createData('سطح 9', <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("co", "9")} {colorSelector("co", "9")} </Paper>, <Paper sx={{ display: "flex", alignItems: "center", m: 0, p: 0, width: "min-content" }}>{toggleIcon("bk", "9")} {colorSelector("bk", "9")}</Paper>,
      rpPsSelector("rp", "9"), rpPsSelector("ps", "9")),
  ];


  return (
    <TableContainer component={Paper}>
      <Divider>سختی لغات(بر اساس لایتنر)</Divider>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>نوع لغت</TableCell>
            <TableCell sx={{ p: 0 }} align="left">رنگ متن</TableCell>
            <TableCell sx={{ p: 0 }} align="left">بک گراند</TableCell>
            <TableCell sx={{ p: 0 }} align="right">تکرار</TableCell>
            <TableCell sx={{ p: 0 }} align="right">توقف</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell sx={{ p: 0 }} component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell sx={{ p: 0 }} align="right">{row.controlCo}</TableCell>
              <TableCell sx={{ p: 0 }} align="right">{row.controlBkCo}</TableCell>
              <TableCell sx={{ p: 0 }} align="right">{row.controlRp}</TableCell>
              <TableCell sx={{ p: 0 }} align="right">{row.controlPs}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography sx={{ fontSize: "smaller" }}>- راهنما :<IconButton onClick={helpClick} color="info"  ><HelpIcon />
      </IconButton></Typography>
      <Button
        onClick={() => {
          handleSubWordLearningStyles({
            co_on: false,
            bk_on: false,
            rp_on: false,
            ps_on: false,
            co_on_1: false,
            co_1: "rgba(0, 255, 2, 1)",
            bk_on_1: false,
            bk_1: "rgba(0, 0, 0, 0.27)",
            rp_1: 0,
            ps_1: 0,
            co_on_2: false,
            co_2: "rgba(0, 255, 2, 1)",
            bk_on_2: false,
            bk_2: "rgba(0, 0, 0, 0.27)",
            rp_2: 0,
            ps_2: 0,
            co_on_3: false,
            co_3: "rgba(0, 255, 2, 1)",
            bk_on_3: false,
            bk_3: "rgba(0, 0, 0, 0.27)",
            rp_3: 0,
            ps_3: 0,
            co_on_4: false,
            co_4: "rgba(0, 255, 2, 1)",
            bk_on_4: false,
            bk_4: "rgba(0, 0, 0, 0.27)",
            rp_4: 0,
            ps_4: 0,
            co_on_5: false,
            co_5: "rgba(0, 255, 2, 1)",
            bk_on_5: false,
            bk_5: "rgba(0, 0, 0, 0.27)",
            rp_5: 0,
            ps_5: 0,
            co_on_6: false,
            co_6: "rgba(0, 255, 2, 1)",
            bk_on_6: false,
            bk_6: "rgba(0, 0, 0, 0.27)",
            rp_6: 0,
            ps_6: 0,
            co_on_7: false,
            co_7: "rgba(0, 255, 2, 1)",
            bk_on_7: false,
            bk_7: "rgba(0, 0, 0, 0.27)",
            rp_7: 0,
            ps_7: 0,
            co_on_8: false,
            co_8: "rgba(0, 255, 2, 1)",
            bk_on_8: false,
            bk_8: "rgba(0, 0, 0, 0.27)",
            rp_8: 0,
            ps_8: 0,
            co_on_9: false,
            co_9: "rgba(0, 255, 2, 1)",
            bk_on_9: false,
            bk_9: "rgba(0, 0, 0, 0.27)",
            rp_9: 0,
            ps_9: 0,
            co_on_10: false,
            co_10: "rgba(0, 255, 2, 1)",
            bk_on_10: false,
            bk_10: "rgba(0, 0, 0, 0.27)",
            rp_10: 0,
            ps_10: 0
          })
        }}
        variant="contained"
        color="error"
        size='small'
        sx={{ left: "31px", position: "absolute", my: 1, p: 0 }}
      >
        ریست تنظیمات لغات کاربر
      </Button>
    </TableContainer>
  );
}